import ApiService from "@services/api.service";
import { Notify} from 'quasar'

export const entrepriseHistoriqueDemarche = {
  state: {
    demarche: null,
    demarches: [],
  },
  mutations: {
    setDemarche(state, demarche){
      state.demarche = demarche;
    },
    setDemarches(state,demarches){
      state.demarches = demarches
    },
    callbackDeleteDemarche(state, demarche){
      for (let inscription in state.demarches) {
        if (state.demarches[inscription].id === demarche) {
          state.demarches.splice(demarche, 1)
        }
      }
    },
  },
  actions: {
    async fetchEntrepriseHistoriqueDemarche(context, idEntreprise){
      try{
        const response = await ApiService.getRequest(`entreprise_historique_demarches?entreprise=${idEntreprise}`);
        context.commit('setDemarches', response.data['hydra:member']);
      }catch(error){
        console.error(error);
        Notify.create({
          message: 'Une erreur s\'est produite',
          color: 'red',
        })
      }
    },
    async addEntrepriseHistoriqueDemarche(context, formData){
      try{
        const response = await ApiService.postRequest(`entreprise_historique_demarches`, formData);
        context.commit('setDemarche', response.data);
        Notify.create({
          message: "La démarche à été enregistrée avec succès",
          color:'green',
        });
      }catch(error){
        console.error(error);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        })
      }
    },
    async updateEntrepriseHistoriqueDemarche(context, { id, data }) {
      try {
        const response = await ApiService.patchRequest(`entreprise_historique_demarches/${id}`, data);
        context.commit('setDemarche', response.data);
        Notify.create({
          message: "La démarche à été enregistrée avec succès",
          color:'green',
        });
        return response.data;
      } catch (error) {
        console.error(error);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        });
      }
    },
    async updateStatusDemarche(context, data){
      try{
        const response = await ApiService.patchRequest(data.id, {etat: data.etat});
        context.commit('setDemarche', response);
        Notify.create({
          message: "Le status a été modifié avec succès",
          color:'green',
        });
        return response;
      }catch(e){
        console.error(e);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        });
      }
    },
    deleteDemarche(context, demarche){
      try {
        const response = ApiService.deleteRequest(demarche);
        context.commit('callbackDeleteDemarche', response);

        Notify.create({
          message: 'Supprimé avec succès',
          color: 'green'
        });
      }catch (e) {
        console.error(e);
        Notify.create({
          message:"Une erreur s'est produite",
          color:'red'
        });
      }
    }
  },
  getters: {
    getDemarches(state){
      return state.demarches;
    },
    getDemarche(state){
      return state.demarche;
    }
  }
}
